"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Panel = _interopRequireDefault(require("../ui/Panel"));

var _LegendView = _interopRequireDefault(require("../../maps/views/legends/LegendView"));

var _utils = require("../utils");

var _utils2 = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * A `LegendPanel` is a panel component that renders and manages a `LegendView` instance.
 *
 * @export
 * @class LegendPanel
 * @extends {Panel<LegendPanelOptions, LegendPanelState>}
 */
var LegendPanel =
/** @class */
function (_super) {
  __extends(LegendPanel, _super);
  /**
   * Initializes and returns a legend panel instance configured with the specified options.
   *
   * @param {LegendPanelOptions} [opts]
   * @memberof LegendPanel
   */


  function LegendPanel(opts) {
    var _this = this;

    opts = (0, _utils2.extend)({
      legend: {
        size: {
          width: 300,
          height: 0
        }
      },
      icon: "\n\t\t\t\t<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 90 90\">\n\t\t\t\t\t<g>\n\t\t\t\t\t\t<path d=\"M45,9c19.9,0,36,16.1,36,36S64.9,81,45,81S9,64.9,9,45C9,25.1,25.1,9,45,9 M45,0C20.1,0,0,20.1,0,45s20.1,45,45,45\n\t\t\t\t\t\t\ts45-20.1,45-45C90,20.1,69.9,0,45,0z\"/>\n\t\t\t\t\t\t<path d=\"M48.7,29.3c0,1-0.4,1.9-1.1,2.7c-0.7,0.7-1.6,1.1-2.6,1.1c-0.5,0-0.9-0.1-1.4-0.3c-0.4-0.2-0.8-0.5-1.2-0.8\n\t\t\t\t\t\t\tc-0.3-0.3-0.6-0.7-0.8-1.2c-0.2-0.5-0.3-0.9-0.3-1.5c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.5-0.8,0.8-1.2c0.3-0.3,0.7-0.6,1.2-0.8\n\t\t\t\t\t\t\tc0.4-0.2,0.9-0.3,1.4-0.3s0.9,0.1,1.4,0.3c0.4,0.2,0.8,0.5,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.1C48.6,28.3,48.7,28.8,48.7,29.3\n\t\t\t\t\t\t\tL48.7,29.3z M48.3,59.8c0,1.1-0.3,2-0.9,2.6c-0.6,0.7-1.4,1-2.4,1s-1.8-0.3-2.4-1c-0.6-0.7-0.9-1.5-0.9-2.6v-18\n\t\t\t\t\t\t\tc0-1.1,0.3-2,0.9-2.6c0.6-0.7,1.4-1,2.4-1s1.8,0.3,2.4,1c0.6,0.7,0.9,1.5,0.9,2.6V59.8z\"/>\n\t\t\t\t\t</g>\n\t\t\t\t</svg>\n\t\t\t"
    }, opts);
    opts.className = (0, _utils2.isset)(opts.className) ? "app__ui-panel-legends " + opts.className : 'app__ui-panel-legends';
    var size = (0, _utils2.get)(opts, 'legend.size');

    if (size) {
      (0, _utils2.set)(opts, 'legend.size.width', Math.min(size.width, (0, _utils.windowSize)().width));
    }

    _this = _super.call(this, opts) || this;
    return _this;
  }

  Object.defineProperty(LegendPanel.prototype, "legend", {
    /**
     * The underlying legend view instance.
     *
     * @readonly
     * @type {LegendView}
     * @memberof LegendPanel
     */
    get: function () {
      return this._legendView;
    },
    enumerable: false,
    configurable: true
  });

  LegendPanel.prototype.open = function () {
    if (this._legendView.count === 0) return;

    _super.prototype.open.call(this);
  };

  LegendPanel.prototype.contentSize = function () {
    var size = _super.prototype.contentSize.call(this); // account for max-height value on container


    var legendSize = this._legendView.getSize();

    var $content = this.getContentContainer();
    size.height = Math.min(legendSize.height, $content.outerHeight(true));
    var pad = $content.padding();
    size.height += pad.top + pad.bottom;
    return size;
  };

  LegendPanel.prototype._onAddedToDOM = function () {
    _super.prototype._onAddedToDOM.call(this);

    this.$el.addClass('awxjs__app__ui-panel-legends');

    if (!this._legendView) {
      this._legendView = new _LegendView.default(this.ui.content, (0, _utils2.extend)({
        styles: {
          label: {
            color: '#ffffff'
          }
        }
      }, this.opts.legend));
    }

    if (this._legendView.count === 0) {
      this.hide();
    }
  };

  LegendPanel.prototype._setupEvents = function () {
    var _this = this;

    _super.prototype._setupEvents.call(this);

    this._legendView.on('add remove', function (e) {
      var count = e.data.count;

      if (count === 0) {
        _this.close();

        _this.hide();
      } else {
        _this.show();
      }
    }).on('resize', function (e) {
      _this._layout();
    });
  };

  return LegendPanel;
}(_Panel.default);

var _default = LegendPanel;
exports.default = _default;
module.exports = exports.default;